import { defineMessages } from 'react-intl';

/**
 * i18n messages for the graph state components (loading, error, empty).
 * All IDs use the twg-visualization. prefix per package convention.
 */
const messages: {
    emptyDescription: {
        defaultMessage: string;
        description: string;
        id: string;
    }; emptyHeading: {
        defaultMessage: string;
        description: string;
        id: string;
    }; errorDescription: {
        defaultMessage: string;
        description: string;
        id: string;
    }; errorHeading: {
        defaultMessage: string;
        description: string;
        id: string;
    }; errorRetry: {
        defaultMessage: string;
        description: string;
        id: string;
    }; loadingLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	loadingLabel: {
		id: 'twg-visualization.state.loading-label',
		defaultMessage: 'Loading graph connections…',
		description: 'Accessible label for the skeleton loading state of the TWG graph',
	},
	emptyHeading: {
		id: 'twg-visualization.state.empty-heading',
		defaultMessage: 'No connections found yet',
		description: 'Heading shown when a space has no TWG relationships',
	},
	emptyDescription: {
		id: 'twg-visualization.state.empty-description',
		defaultMessage:
			'Connections between this space and other Atlassian content will appear here as your team collaborates.',
		description: 'Description shown when a space has no TWG relationships',
	},
	errorHeading: {
		id: 'twg-visualization.state.error-heading',
		defaultMessage: 'Graph connections are unavailable right now',
		description: 'Heading shown when graph data fails to load',
	},
	errorDescription: {
		id: 'twg-visualization.state.error-description',
		defaultMessage: 'There was a problem loading this space\u2019s connections. Please try again.',
		description: 'Description shown when graph data fails to load',
	},
	errorRetry: {
		id: 'twg-visualization.state.error-retry',
		defaultMessage: 'Try again',
		description: 'Label for the retry button shown on the graph error state',
	},
});

export default messages;
